module.exports = __webpack_public_path__ + "img/customizer-01.a910b6ca.png";